import { render, staticRenderFns } from "./OrdersCard.vue?vue&type=template&id=04a70fec&scoped=true&"
import script from "./OrdersCard.vue?vue&type=script&lang=js&"
export * from "./OrdersCard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCard.vue?vue&type=style&index=0&id=04a70fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a70fec",
  null
  
)

export default component.exports